import { render, staticRenderFns } from "./TextProgrammeMore.vue?vue&type=template&id=e9ec4602&scoped=true"
import script from "./TextProgrammeMore.vue?vue&type=script&lang=js"
export * from "./TextProgrammeMore.vue?vue&type=script&lang=js"
import style0 from "./TextProgrammeMore.vue?vue&type=style&index=0&id=e9ec4602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ec4602",
  null
  
)

export default component.exports